import styled, { css, keyframes } from 'styled-components';
import { hiDPI } from 'polished';
import { BACKGROUND_HEIGHT, BACKGROUND_WIDTH, JUMP_DELAY } from '@config';
import { StonesType, MoneyPositionType, GameStatus } from '@containers';
import { stonesMapping, mapping, moneysMapping } from './assets';

const runAnimation = keyframes`
  0% {
    background-position: 0;
  }
  100% {
    background-position: -4914px;
  }
`;

const jumpAnimation = keyframes`
  0% {
    background-position: 0;
  }
  100% {
    background-position: -2886px;
  }
`;

const failAnimation = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const GameBackground = styled.div<{ backgroundScale: number; }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${mapping.gameBackground['1x']}) repeat-x;
  background-size: ${({ backgroundScale }) => `${BACKGROUND_WIDTH * backgroundScale}px ${BACKGROUND_HEIGHT * backgroundScale}px`};
  transform: translateZ(0);
  z-index: 10;
`;

export const Stone = styled.div<{ variant: StonesType; }>`
  position: absolute;
  bottom: 120px;
  left: calc(100% + 100px);
  width: ${({ variant }) => stonesMapping[variant].width}px;
  height: ${({ variant }) => stonesMapping[variant].height}px;
  background: url(${({ variant }) => stonesMapping[variant]['1x']}) no-repeat;
  z-index: 20;

  ${hiDPI(2)} {
    background: url(${({ variant }) => stonesMapping[variant]['2x']});
    background-size: ${({ variant }) => `${stonesMapping[variant].width}px ${stonesMapping[variant].height}px`};
  }
`;

export const Money = styled.div<{ position: MoneyPositionType; }>`
  position: absolute;
  bottom: ${({ position }) => position === 'top' ? 600 : 120}px;
  left: calc(100% + 100px);
  width: 220px;
  height: 220px;
  background: url(${moneysMapping['money-1']['1x']}) no-repeat;
  z-index: 20;

  ${hiDPI(2)} {
    background: url(${moneysMapping['money-1']['2x']});
    background-size: 220px;
  }
`;

export const Land = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 171px;
  background: url(${mapping.land['1x']}) repeat-x;
  transform: translateZ(0);
  z-index: 40;

  ${hiDPI(2)} {
    background: url(${mapping.land['2x']});
    background-size: 415px 171px;
  }
`;

export const Men = styled.div<{ jumpAnimationActive: boolean; gameStatus: GameStatus; }>`
  position: absolute;
  bottom: 130px;
  left: 100px;
  width: 273px;
  height: 394px;
  background: url(${mapping.run['1x']}) no-repeat;
  animation: ${runAnimation} 1000ms infinite steps(18);

  ${hiDPI(2)} {
    background: url(${mapping.run['2x']});
    background-size: 4914px 394px;
  }
  
  ${({ jumpAnimationActive }) => jumpAnimationActive && css`
    bottom: 600px;
    width: 222px;
    height: 455px;
    background: url(${mapping.jump['1x']}) no-repeat;
    animation: ${jumpAnimation} 1000ms infinite steps(13);

    ${hiDPI(2)} {
      background: url(${mapping.jump['2x']});
      background-size: 2886px 455px;
    }
  `}
  
  ${({ gameStatus }) => gameStatus !== 'play' && css`
    animation-play-state: paused;
  `}
  
  transition: bottom ${JUMP_DELAY / 2}ms ease;
  z-index: 30;
`;

export const Fail = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(70.45% 72.11% at 50% 50%, rgba(0, 0, 0, 0) 0%, #FF0000 100%);
  mix-blend-mode: lighten;
  animation: ${failAnimation} 2000ms infinite ease;
  z-index: 50;
`;